export default defineNuxtRouteMiddleware(to => {
  const tokens = getTokens()

  const ignoredPaths = ['/auth', '/auth/recovery']

  if (!tokens?.refresh && !ignoredPaths.includes(to.path) && !to.path.startsWith('/preview')) {
    if (to.path.startsWith('/details')) {
      return navigateTo(to.path.replace('details', 'preview'))
    }
    if (to.fullPath !== '/') {
      return navigateTo({ path: '/auth', query: { redirect: to.fullPath } })
    } else {
      return navigateTo('/auth')
    }
  }
})
